import React, { useContext ,useEffect} from 'react'
import { Context } from "../context/Context"
import { allahNames } from "../Database/Database"
import { Link } from "react-router-dom";
import { SendGuiDataEvents } from '../lib/CommonScript';

function AllahNames() {

  const { lang ,theme} = useContext(Context);


  fetch("../Database/sample.json")
  .then(function(resp) {
    return resp
  })
  .then(function(data){
    return data.json()
  })
  .then(function (Normal){
    console.log("fetching local data using fetch ----> ",Normal)
  })

  useEffect(() => {
    //send gui events
    let guiDataEvent = {};
    guiDataEvent["w_action"] = "card_click";
        guiDataEvent["name"] = "allah_names";
    SendGuiDataEvents(guiDataEvent);
  }, []);



  return (
    <div className={`min-h-screen h-full  bg-cover bg-center bg-no-repeat  ${theme === "red" ? "bg-red_bg_pic": "bg-green_bg_pic"} pt-24 max-width`}>
      <div className='flex flex-col justify-between w-3/4 mx-auto h-85v'>
        <div className='h-full  w-fullml-1 -mt-5 px-auto my-0 overflow-y-auto py-6'>
          {
            allahNames && allahNames[lang].map((data, index) => {
              return (
                <div key = {index} className={`w-full border-b ${theme === 'red' ? "border-red-900" : "border-white-400 text-white" } py-2 text-xl`}>
                  {data}
                </div>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}

export default AllahNames